import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import GameStore, {normalizeLetters} from "../../store/game";

// Клавиатура из текущего набора букв
export const LetterPad = observer(({onLetter, onEnter, onBackspace}) => {
    const letters = normalizeLetters(GameStore.letters);
    // Сохраняем позиции уже выбранных букв, чтобы выделять только конкретные клавиши
    const usedIndexes = new Set(
        GameStore.attempt
            .map((letter) => (Number.isFinite(letter?.keyIndex) ? letter.keyIndex : null))
            .filter((value) => value !== null)
    );

    useEffect(() => {
            const handleKeyDown = (event) => {
                const key = event.key.toLowerCase();

                if (letters.includes(key)) {
                    onLetter({letter: key, source: "keyboard"});
                    return;
                }

                if (key === "enter") {
                    onEnter();
                    return;
                }

                if (key === "backspace") {
                    onBackspace();
                }
            };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [letters, onLetter, onEnter, onBackspace]);

    return (
        <>
            <div className="px-4 py-2 flex flex-wrap gap-2 justify-center">
                {letters.map((letter, index) => (
                    <button
                        key={`${letter}-${index}`}
                        type="button"
                        className={`w-11 h-11 border border-gray-600 rounded-lg text-lg uppercase active:scale-95 transition ${
                            usedIndexes.has(index)
                                ? "bg-white text-gray-900 border border-white"
                                : "bg-gray-800 text-gray-100 hover:bg-gray-700"
                        }`}
                        onClick={() => onLetter({letter, source: "click", index})}
                    >
                        {letter}
                    </button>
                ))}
            </div>

            <div className="flex w-full gap-2 justify-center mt-2">
                <button
                    type="button"
                    className="h-10 px-4 py-1 rounded-lg bg-gray-800 text-gray-100 hover:bg-gray-700 active:scale-95 transition"
                    onClick={onBackspace}
                >
                    Delete
                </button>

                <button
                    type="button"
                    className="h-10 px-4 py-1 rounded-lg bg-yellow-500 text-gray-900 hover:bg-yellow-400 active:scale-95 transition"
                    onClick={onEnter}
                >
                    Submit
                </button>
            </div>
        </>
    );
});
